import React from 'react';
import './leafletBaseLayerToggle.css';

export type LeafletBaseLayer = 'map' | 'satellite';
export type LeafletLabelsState = Record<LeafletBaseLayer, boolean>;

interface Props {
    activeLayer: LeafletBaseLayer;
    labelsByLayer: LeafletLabelsState;
    onLayerChange: (layer: LeafletBaseLayer) => void;
    onLabelsChange: (layer: LeafletBaseLayer, enabled: boolean) => void;
}

const labels: Record<LeafletBaseLayer, string> = {
    map: 'Map',
    satellite: 'Satellite'
};

function LeafletBaseLayerToggle({ activeLayer, labelsByLayer, onLayerChange, onLabelsChange }: Props) {
    return (
        <div className="leaflet-base-layer-control">
            <div className="leaflet-base-layer-control__tabs" role="tablist" aria-label="Map layers">
                {(Object.keys(labels) as LeafletBaseLayer[]).map((layer) => {
                    const isActive = activeLayer === layer;

                    return (
                        <div
                            key={layer}
                            className={`leaflet-base-layer-control__tab-group${isActive ? ' is-active' : ''}`}
                        >
                            <button
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                className={`leaflet-base-layer-control__tab${isActive ? ' is-active' : ''}`}
                                onClick={() => onLayerChange(layer)}
                            >
                                {labels[layer]}
                            </button>
                            <label className="leaflet-base-layer-control__labels">
                                <input
                                    type="checkbox"
                                    checked={labelsByLayer[layer]}
                                    onChange={(event) => onLabelsChange(layer, event.target.checked)}
                                />
                                <span>Labels</span>
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default React.memo(LeafletBaseLayerToggle);
